import { render, staticRenderFns } from "./Pant.vue?vue&type=template&id=c20ad810&scoped=true"
import script from "./Pant.vue?vue&type=script&lang=js"
export * from "./Pant.vue?vue&type=script&lang=js"
import style0 from "./Pant.vue?vue&type=style&index=0&id=c20ad810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20ad810",
  null
  
)

export default component.exports